import {css} from "styled-components";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const MiscellaneousCss = css`
  :root {
    --farmy-orange: ${theme.colors.farmy.orange};
  }

  .soft-shadow {
    box-shadow: 1px 1px 8px -3px rgba(0, 0, 0, .3);
  }

  .soft-revert-shadow {
    box-shadow: 1px -3px 6px -3px rgba(0, 0, 0, 0.3);
  }
  
  .soft-shadow-small {
    box-shadow: 1px 1px 4px 0 rgba(0,0,0,.3);
  }

  .height-fit-content {
    height: fit-content;
  }

  .background-color-white {
    background-color: white;
  }

  .background-color-green {
    background-color: ${theme.colors.farmy.green};
  }

  .background-color-orange {
    background-color: ${theme.colors.farmy.orange};
  }

  .background-color-transparent {
    background-color: transparent;
  }

  .background-color-transparent {
    background-color: transparent;
  }

  .background-color-dimmed {
    background-color: ${theme.colors.farmy.dimmedWhite};
  }
  
  .background-color-light-grey {
    background-color: ${theme.colors.farmy.lightgrey};
  }

  .background-color-lighter-grey {
    background-color: ${theme.colors.farmy.lighterGrey};
  }

  .background-color-very-light-grey {
    background-color: ${theme.colors.farmy.veryLightGrey};
  }

  .background-color-lightest-grey {
    background-color: ${theme.colors.farmy.lightestGrey};
  }

  .background-color-almost-white {
    background-color: ${theme.colors.farmy.almostWhite};
  }
  
  .border-none {
    border: none;
  }
  
  .border-default {
    border: 1px solid;
  }
  
  .border-radius-0 {
    border-radius: 0;
  }
  
  .border-radius-xs {
    border-radius: ${theme.borderRadius.xs};
  }
  
  .border-radius-sm {
    border-radius: ${theme.borderRadius.sm};
  }

  .border-radius-md {
    border-radius: ${theme.borderRadius.md};
  }

  .border-radius-lg {
    border-radius: ${theme.borderRadius.lg};
  }

  .border-radius-xl {
    border-radius: ${theme.borderRadius.xl};
  }
  
  .border-radius-full {
    border-radius: 50%;
  }

  .border-color-light {
    border-color: ${theme.colors.farmy.veryLighterGrey};
  }
  
  .border-color-lightest-grey {
    border-color: ${theme.colors.farmy.lightestGrey};
  }
  
  .border-color-dimmed-white {
    border-color: ${theme.colors.farmy.dimmedWhite}
  }
  
  .border-color-medium {
    border-color: #999999;
  }
  
  .border-color-white {
    border-color: white;
  }

  .border-color-green {
    border-color: ${theme.colors.farmy.green};
  }

  .cursor-pointer {
    cursor: pointer;
  }
  
  .transition-all-default, .transition-all-fast {
    transition: all ${theme.transitionTime.fast}ms;
  }
  
  .transition-all-slow {
    transition: all ${theme.transitionTime.slow}ms;
  }

  .transition-all-medium {
    transition: all ${theme.transitionTime.medium}ms;
  }
`;

export default MiscellaneousCss;
